import { render } from "./AppInput.vue?vue&type=template&id=bbb54c84&scoped=true"
import script from "./AppInput.vue?vue&type=script&lang=js"
export * from "./AppInput.vue?vue&type=script&lang=js"

import "./AppInput.vue?vue&type=style&index=0&id=bbb54c84&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbb54c84"]])

export default __exports__